import { Reveal, GoldDivider } from "./Reveal";
import { GALLERY } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const SPANS = [
  "md:col-span-7 md:row-span-2",
  "md:col-span-5",
  "md:col-span-5",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
];

const Gallery = () => {
  const { t } = useLang();
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="text-center">
          <p className="overline text-gold">{t.gallery.overline}</p>
          <h2 className="mt-2 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl">
            {t.gallery.title}
          </h2>
          <GoldDivider />
        </Reveal>

        <div className="mt-14 grid auto-rows-[220px] grid-cols-1 gap-5 md:grid-cols-12 md:auto-rows-[230px]">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              className={`${SPANS[i]} group relative overflow-hidden`}
            >
              <div data-testid={`gallery-item-${i}`} className="spotlight h-full w-full">
                <img
                  src={g.image}
                  alt={g.alt}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/30" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
